import { IOption } from '@design-system/elements/Select/Select.types';
import { IBeneficiary } from 'src/shared/types/Beneficiary';
import { IDependent } from 'src/shared/types/Dependent';

export interface IProfileState {
  fullName: string;
  firstName: string;
  middleName: string;
  lastName: string;
  preferredName: string;
  otherName: string;
  dob: string;
  stateProvinceOfBirth: string;
  cityOfBirth: string;
  citizenship?: string;
  prefix?: IOption | null;
  relationship: IOption | null;
  gender?: IOption | null;
  maritalStatus?: IOption | null;
  cob?: IOption | null;
  nationalities: IOption[];
}

export const InitialProfileState: IProfileState = {
  fullName: '',
  firstName: '',
  middleName: '',
  lastName: '',
  preferredName: '',
  otherName: '',
  dob: '',
  citizenship: '',
  stateProvinceOfBirth: '',
  cityOfBirth: '',
  cob: null,
  prefix: null,
  relationship: null,
  gender: null,
  maritalStatus: null,
  nationalities: [],
};

export const getInitialStateData = (userProfile: IBeneficiary | IDependent): IProfileState => {
  if (!userProfile) return InitialProfileState;

  return {
    prefix: null,
    relationship: null,
    fullName: userProfile.fullName || '',
    firstName: userProfile.firstName || '',
    middleName: userProfile.middleName || '',
    lastName: userProfile.lastName || '',
    preferredName: userProfile.preferredName || '',
    otherName: userProfile.otherName || '',
    citizenship: userProfile.citizenship || '',
    gender: null,
    maritalStatus: null,
    dob: userProfile.dob || '',
    stateProvinceOfBirth: userProfile.stateProvinceOfBirth || '',
    cityOfBirth: userProfile.cityOfBirth || '',
    cob: userProfile.cob ? { label: userProfile.cob, value: userProfile.cob } : null,
    nationalities: userProfile.nationalities
      ? userProfile.nationalities.map((item) => ({ label: item.countryName, value: item.countryCode }))
      : [],
  };
};
